import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TAccordionMode } from '@shared/v2';
import { AccordionService } from './accordion.service';

@Component({
  selector: 'sd-accordion',
  standalone: true,
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdAccordionComponent implements OnChanges, OnInit {
  @Input() mode: TAccordionMode = 'multiple';
  @Input() watchIds: string[] = [];

  @Output() watcherIds = new EventEmitter<{
    [key: string]: boolean;
  }>();

  constructor(
    private destroyRef: DestroyRef,
    private accordionService: AccordionService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mode']) {
      this.accordionService.setMode(this.mode);
    }
  }

  ngOnInit(): void {
    this.accordionService
      .watchMultiple(this.watchIds)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((obj) => {
        this.watcherIds.emit(obj);
      });
  }
}
